import { z } from 'zod';

// search-report-file API validation schemas
export const SearchReportFileRequestSchema = z
  .object({
    LaboratoryId: z.string(),
    S3Bucket: z.string().optional(),
    S3Prefix: z.string(),
    FileName: z.string(),
  })
  .strict();

export const SearchReportFileResponseSchema = z
  .object({
    Found: z.boolean(),
    S3Key: z.string().optional(),
    Size: z.number().optional(),
    LastModified: z.string().optional(),
    IsTruncated: z.boolean().optional(),
    KeyCount: z.number().optional(),
  })
  .strict();
